import { Fragment, h, JSX } from "@stencil/core";
import { navContentStore } from "@phn/state/nav-content-store";
import { shouldShowBackButton } from "../../../../shared/services/routing-manager";

export default function DrawerContent({
  routingKey,
  breakpoint,
  locale,
  receivedContent,
}: {
  routingKey: string;
  breakpoint: number;
  locale: string;
  receivedContent: boolean;
}): JSX.Element {
  const { menu } = navContentStore.state;
  return (
    <Fragment>
      <div class="drawer-content">
        <phn-nd-drawer-header
          showBackButton={shouldShowBackButton(routingKey)}
          backButtonAnalyticsId={menu.id}
          breakpoint={breakpoint}
          route={routingKey}
          receivedContent={receivedContent}
          locale={locale}
        />
        <phn-nd-router
          activeRoutingKey={routingKey}
          breakpoint={breakpoint}
          locale={locale}
          receivedContent={receivedContent}
        />
      </div>
    </Fragment>
  );
}
